import { apiService } from "@/services";
import { settings } from "@/settings";
import { BrandsClient } from "./GeneratedClients";

const brandRepository = new BrandsClient(settings.webApi.baseUrl, apiService.getApiClient());

export { brandRepository };

